import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit{
  public activate = false;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        console.log('query params', params);
        if (params.action === 'settings') {
          const url = window.location.href;

          if (url.indexOf('dev.activate') > -1) {
            window.location.href = 'https://admin.partnertest.call2.team';
          } else {
            window.location.href = 'https://portal.connectforteams.cloud';
          }
        } else if(params.action === 'activate') {
          this.activate = true;
        }
      }
    );
  }
}
